import script from "./AppSplash.vue?vue&type=script&setup=true&lang=js"
export * from "./AppSplash.vue?vue&type=script&setup=true&lang=js"

import "./AppSplash.vue?vue&type=style&index=0&id=7099cb03&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7099cb03"]])

export default __exports__